<template>
    <el-dialog title="司机信息" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-position="left" size="small">
            <!-- <el-form-item label="司机姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入司机姓名" maxlength="50"></el-input>
            </el-form-item> -->

            <el-form-item label="手机号码" prop="phone" v-if="editType == 'phone'">
                <el-input v-model="form.phone" placeholder="请输入手机号码" maxlength="11"></el-input>
            </el-form-item>

            <el-form-item label="司机头像" prop="headPortrait" v-if="editType == 'avatar'">
                <up-img :file.sync="form.headPortrait" width="120" height="120"></up-img>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">提 交</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: 'DriverInfoDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        driverInfo: {
            type: Object,
            default: () => { }
        },
        loading: {
            type: Boolean,
            default: false
        },
        editType: {
            type: String,
            default: 'phone'
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val
        },
        dialogVisible(val) {
            this.$emit('update:visible', val)
        },
        driverInfo: {
            handler(val) {
                if (val) {
                    this.initForm()
                }
            },
            immediate: true
        },
    },
    data() {
        // 手机号验证规则
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号码'))
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'))
            } else {
                callback()
            }
        }

        return {
            dialogVisible: false,
            form: {
                name: '',
                phone: '',
                headPortrait: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入司机姓名', trigger: ['blur', 'change'] }
                ],
                phone: [
                    { required: true, validator: validatePhone, trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        initForm() {
            this.form = {
                name: this.driverInfo.name,
                phone: this.driverInfo.phone,
                headPortrait: this.driverInfo.headPortrait,
            }
        },
        // 打开弹窗
        open() {
            this.dialogVisible = true
        },
        // 提交表单
        submitForm() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.$emit('submit', this.form)
                }
            })
        }
    }
}
</script>